import { IHinhThucThanhToanActions } from "../../action-types/category/IHinhThucThanhToanActionType";
import { IHinhThucThanhToanReducer } from "../../reducer-model/category/IHinhThucThanhToanReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IHinhThucThanhToanReducer = {
    status: eReducerStatusBase.is_not_initialization,
    hinhThucThanhToans: []
}
export const hinhThucThanhToanReducer = (state: IHinhThucThanhToanReducer = iniState, action: IHinhThucThanhToanActions): IHinhThucThanhToanReducer => {
    switch (action.type) {
        case "HINH_THUC_THANH_TOAN_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "HINH_THUC_THANH_TOAN_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                hinhThucThanhToans: action.payload
            }
        case "HINH_THUC_THANH_TOAN_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "HINH_THUC_THANH_TOAN_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                hinhThucThanhToanEditing: action.payload
            }
        case "HINH_THUC_THANH_TOAN_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "HINH_THUC_THANH_TOAN_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "HINH_THUC_THANH_TOAN_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            }
        case "HINH_THUC_THANH_TOAN_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "HINH_THUC_THANH_TOAN_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "HINH_THUC_THANH_TOAN_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "HINH_THUC_THANH_TOAN_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        default:
            return state;
    }
}